/** @file The id prefixes Pose3D issues, one per kind of stored object. */

/** Id prefixes: puppet, clip, image, project, token, library. */
export const ID_PREFIXES = ['pup', 'clp', 'img', 'prj', 'tok', 'lib'] as const;

/** One of `ID_PREFIXES`. */
export type IdPrefix = (typeof ID_PREFIXES)[number];
